import {
  PYPESTREAM_INTERFACE_ID,
  PYPESTREAM_MOUNTED,
  PYPESTREAM_SCRIPT_ID,
  REDIRECT_TO_LOGIN,
} from './constants';

export const html = ({ scriptUrl }: { scriptUrl: string }) => `
  <!DOCTYPE html>
  <html>
    <head>
      <meta charset="utf-8">
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, viewport-fit=cover, minimum-scale=1.0, maximum-scale=1.0"
      >
      <title>Pypestream</title>
      <style>
        body {
          margin: 0;
        }
      </style>
    </head>
    <body>
      <main id="${PYPESTREAM_INTERFACE_ID}"></main>
      <script id="${PYPESTREAM_SCRIPT_ID}" src="${scriptUrl}"></script>
      <script>
        window.addEventListener(
          'message',
          event => {
            if (
              event.origin?.endsWith('pypestream.com') &&
              event.data === '${REDIRECT_TO_LOGIN}'
            ) {
              window.ReactNativeWebView.postMessage(event.data)
            }
          },
          false
        );
        window?.Pypestream?.('onMount', () => {
          window.ReactNativeWebView.postMessage('${PYPESTREAM_MOUNTED}');
        });
      </script>
    </body>
  </html>
`;

export const shutdownJS = () => `
  window?.Pypestream?.shutdown();
  true;
`;

export const bootJS = ({
  appId,
  cognitoId,
  forterDeviceId,
  forterToken,
  language,
  stage,
  welcomeMessage,
  isoCountryCode,
  rbiOrderId,
  topic,
}: {
  appId: string;
  cognitoId: string;
  forterDeviceId: string;
  forterToken: string;
  language: string;
  stage: string;
  welcomeMessage: string;
  isoCountryCode: string;
  rbiOrderId: string;
  topic: string;
}) => `
  window?.Pypestream?.boot(
    {
      APP_ID: '${appId}',
      disableWidgetSlideInOutAnimation: true,
      initialMessages: {
        isPersistent: true,
        showNextThinkingBubble: true,
        welcomeMessage: "${welcomeMessage}",
      },
      language: '${language}',
      passthrough: JSON.stringify([
        { attribute: 'stage', label: 'stage', value: '${stage}', visible: 'wpm' },
        { attribute: 'forterDeviceId', label: 'forterDeviceId', value: '${forterDeviceId}', visible: 'wpm' },
        { attribute: 'forterToken', label: 'forterToken', value: '${forterToken}', visible: 'wpm' },
        { attribute: 'isoCountryCode', label: 'isoCountryCode', value: '${isoCountryCode}', visible: 'wpm' },
        { attribute: 'isRN', label: 'isRN', value: true, visible: 'wpm' },
        { attribute: 'userAgent', label: 'userAgent', value: window.navigator.userAgent, visible: 'wpm' },
        { attribute: 'rbiOrderId', label: 'orderId', value: '${rbiOrderId}', visible: 'wpm'},
        { attribute: 'topic', label: 'topic', value: '${topic}', visible: 'wpm' }
      ]),
      play_chime: false,
      token: '${cognitoId}',
      withInlineAppLoader: false,
    },
    document.getElementById('${PYPESTREAM_INTERFACE_ID}')
  );
  true;
`;
